import { Ng2StateDeclaration } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiDocumentTemplateRootState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Template._name,
    url: '/Template',
    abstract: true,
    component: FiAbstractStateComponent,
};

export function registerDocumentTemplateStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Document.Template.View], {
        SettingType: [ApplicationSettingsType.DocumentCentral, ApplicationSettingsType.DocumentLocal],
        AccessType: AccessRightType.Read,
    });

    stateAccessCheckService.registerStateRules(
        [FiStateNames.Document.Template.Edit, FiStateNames.Document.Template.Add],
        {
            SettingType: [ApplicationSettingsType.DocumentCentral, ApplicationSettingsType.DocumentLocal],
            AccessType: AccessRightType.Admin,
        },
    );
}
